import { createContext, useContext, useCallback, type ReactNode } from 'react'
import { Toaster, toast } from 'sonner'

type ToastContextValue = {
  success: (message: string) => void
  error: (message: string) => void
  info: (message: string) => void
  warning: (message: string) => void
}

const ToastContext = createContext<ToastContextValue | null>(null)

export function ToastProvider({ children }: { children: ReactNode }): React.ReactElement {
  const success = useCallback((message: string) => toast.success(message), [])
  const error = useCallback((message: string) => toast.error(message), [])
  const info = useCallback((message: string) => toast.info(message), [])
  const warning = useCallback((message: string) => toast.warning(message), [])

  return (
    <ToastContext.Provider value={{ success, error, info, warning }}>
      {children}
      <Toaster
        position="top-center"
        dir="rtl"
        toastOptions={{
          style: { fontFamily: 'IBM Plex Sans Arabic, system-ui, sans-serif' },
        }}
      />
    </ToastContext.Provider>
  )
}

export function useToast(): ToastContextValue {
  const context = useContext(ToastContext)
  if (!context) throw new Error('useToast must be used within ToastProvider')
  return context
}
